import { render } from "./ThankYouPage.vue?vue&type=template&id=7e772d2c&scoped=true"
import script from "./ThankYouPage.vue?vue&type=script&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&lang=js"

import "./ThankYouPage.vue?vue&type=style&index=0&id=7e772d2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e772d2c"]])

export default __exports__